import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle, ArrowRight } from 'lucide-react';

export const InstructionGuide = ({ title, description, steps = [], flow = [] }) => {
  const [open, setOpen] = useState(false);

  return (
    <div data-testid="instruction-guide" className="mb-4 border border-blue-100 rounded-lg bg-blue-50/50 overflow-hidden">
      <button
        data-testid="guide-toggle"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-blue-50 transition-colors"
      >
        <HelpCircle className="w-4 h-4 text-blue-500 flex-shrink-0" />
        <span className="text-sm font-semibold text-blue-800 flex-1">{title || 'How it works'}</span>
        {open ? <ChevronUp className="w-4 h-4 text-blue-400" /> : <ChevronDown className="w-4 h-4 text-blue-400" />}
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3">
          {description && <p className="text-xs text-blue-700 leading-relaxed">{description}</p>}
          {steps.length > 0 && (
            <div>
              <p className="text-[10px] font-bold text-blue-800 uppercase tracking-wider mb-1.5">Steps</p>
              <ol className="space-y-1">
                {steps.map((s, i) => (
                  <li key={i} className="flex items-start gap-2 text-xs text-blue-700">
                    <span className="w-4 h-4 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center text-[10px] font-bold flex-shrink-0 mt-0.5">{i + 1}</span>
                    <span>{s}</span>
                  </li>
                ))}
              </ol>
            </div>
          )}
          {flow.length > 0 && (
            <div>
              <p className="text-[10px] font-bold text-blue-800 uppercase tracking-wider mb-1.5">Flow</p>
              <div className="flex flex-wrap items-center gap-1">
                {flow.map((f, i) => (
                  <React.Fragment key={i}>
                    <span className="px-2 py-1 bg-white border border-blue-200 rounded text-[10px] font-semibold text-blue-800 whitespace-nowrap">{f}</span>
                    {i < flow.length - 1 && <ArrowRight className="w-3 h-3 text-blue-300 flex-shrink-0" />}
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
